/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_RecentInputs */

const en_mcp_cap_library_recent = /** @type {(inputs: Mcp_Cap_Library_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent documents`)
};

const es_mcp_cap_library_recent = /** @type {(inputs: Mcp_Cap_Library_RecentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos recientes`)
};

/**
* | output |
* | --- |
* | "Recent documents" |
*
* @param {Mcp_Cap_Library_RecentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_recent = /** @type {((inputs?: Mcp_Cap_Library_RecentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_RecentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_recent(inputs)
	return en_mcp_cap_library_recent(inputs)
});